import { connect } from '@formily/react-schema-renderer';
import { Rate } from 'antd';
import { mapStyledProps } from '../shared';
export var Rating = connect({
    getProps: mapStyledProps
})(Rate);
export default Rating;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/rating/index.js
// module id = 2104
// module chunks = 0